import { FormMarkup } from '@components/basicComponents';
import { getSortedFormFields, handleFormSubmit } from '@utils/forms';
import type { FormExtendedEvent } from 'grommet/components/Form';
import type { FormProps } from '@customTypes/types';

const formTitle: string = 'HPE Support Request';

export const RPLSupportForm = (props: FormProps): JSX.Element => {
  const onSubmit = ({ target }: FormExtendedEvent): void => {
    const namespace = 'hpe_rpl_supportcenter_dce';
    const subject = 'RPL, {formId}';
    const data = getSortedFormFields(target, namespace, subject);

    handleFormSubmit(data, props.onSuccess, props.onError, props.onLoading);
  };

  return (
    <FormMarkup
      onSubmit={onSubmit}
      formTitle={formTitle}
      disclaimer={'Please fill out the following information so that we may investigate your issue and respond back to you with information to resolve your question.'}
      passportId
      applicationUrl
      country
    />
  );
};
